/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef } from 'react';

import { css, cx } from '@emotion/css';
import { observer } from 'mobx-react-lite';
import { useMediaQuery } from 'react-responsive';

import { TextInput } from '^/commonComponents/inputs/TextInput';
import { SPACING, COLORS2, font, INPUT } from '^/constants/commonStyles';

import { classNames } from '../../../base/desktop/contentsArea/CarSearchBox.contentsArea.style';
import { CarListingSearchBoxViewModel } from '../../../base/desktop/viewmodel/CarListingSearchBox.viewmodel';

function getStyleByStatus(viewmodel: CarListingSearchBoxViewModel) {
  if (viewmodel.birthdayAgeValidation.status === 'failure') {
    return css`
      border: 1px solid red;
    `;
  }
  if (viewmodel.stepManager.currentStep?.type === '4_birthday') {
    return css`
      border: 1px solid ${COLORS2.main.MrtBlue1};
      color: ${COLORS2.main.MrtBlack};
    `;
  }
  return '';
}
export const MRTBirthDayInputMobile: React.FC<{
  viewmodel: CarListingSearchBoxViewModel;
  title?: React.ReactNode;
}> = observer(function MRTBirthDayInputMobile({ viewmodel, title = '운전자 생년월일' }) {
  const birthdayInputRef = useRef<HTMLInputElement>(null);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  useEffect(() => {
    if (viewmodel.stepManager.currentStep?.type === '4_birthday') {
      birthdayInputRef.current?.focus();
    }
  }, [viewmodel.stepManager.currentStep]);

  return (
    <div
      className={cx(
        classNames.common.searchBoxInputWrapper,
        css`
          display: flex;
          gap: 8px;
        `,
        // borders.DEBUG_blueBorderDashed,
      )}
    >
      <div className={classNames.common.searchBoxInputTitle}>{title}</div>
      <div
        className={[
          css`
            position: relative;
            display: flex;
            align-items: center;
          `,
          !isMobile &&
            css`
              height: 48px;
            `,

          // borders.DEBUG_greenBorderDashed,
        ].join(' ')}
      >
        <img
          alt="user-square"
          src="user-square.svg"
          className={css`
            margin-right: 6px;
            width: 16px;
            height: 16px;
            position: absolute;
            left: 16px;
          `}
        />
        <TextInput
          autoComplete="birthday"
          rootRef={birthdayInputRef}
          name="BIRTHDAY"
          maxLength={6}
          onBlur={(e) => {
            viewmodel.stepManager.clearStep();
          }}
          className={cx(
            classNames.common.searchBoxInputsMRT,
            INPUT.hideArrow,
            INPUT.overflowEllipsis,
            css`
              outline: none;
              padding: ${SPACING.spacing16};
              padding-left: 38px;
              border-radius: 8px;
              width: 100%;
              border: 1px solid #cecece;
              font-size: 14px;
              font-weight: 500;
              color: ${COLORS2.main.MrtBlack};
              &::placeholder {
                color: ${COLORS2.sub.MrtGray1};
              }
              /* &:focus &:focus-within { */
              &:focus-within {
                background-color: ${COLORS2.main.MrtWhite};
                border: 1px solid #cecece;
              }
            `,
            !isMobile &&
              css`
                height: 48px;
                font-size: 16px;
              `,

            // viewmodel.ageInput.isFocused
            getStyleByStatus(viewmodel),
          )}
          placeholder="YYMMDD"
          viewmodel={viewmodel.i.birthdayInput}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
        />
        {viewmodel.birthdayAgeValidation.status === 'failure' && (
          <div
            className={cx(
              font.Caption1_Light,
              css`
                position: absolute;
                color: red;
                left: 0px;
                top: 100%;
                width: max-content;
              `,
            )}
          >
            {viewmodel.birthdayAgeValidation.failure.reason}
          </div>
        )}
      </div>
    </div>
  );
});
